<template>
  <div class="container terms">
    <vue-headful title="Terms and conditions | bilaskra.is" description="terms and conditions" />
    <div v-for="(v,i) in accordion" :key="i" >
      <h2 class="terms-header" v-text="v.title"></h2>
      <div class="terms-content" v-html="v.content"></div>
    </div>
  </div>
</template>


<script>
import terms from "@/store/terms";
export default {
  data: () => ({
    accordion: terms.terms,
    selectTabIndex: -1
  })
}
</script>